import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ConditionalView } from "../../components/conditional-view";
import Facebook from "@rip/icons/facebook.svg";
import Instagram from "@rip/icons/instagram.svg";
import Telegram from "@rip/icons/telegram.svg";
import Twitter from "@rip/icons/twitter.svg";
import Viber from "@rip/icons/viber.svg";
import Whatsapp from "@rip/icons/whatsapp.svg";
const TextContainer = ({ title = "", subHeadline = "", description = "", iconList = [], }) => {
    const listItems = iconList?.map((icon, idx) => {
        const iconName = icon.name;
        return (_jsx("li", { className: "aem-pushblock__icon-item", children: _jsx("a", { "aria-label": icon.label, className: "aem-pushblock__icon-link", href: icon.link, target: "_blank", title: icon.label, rel: "noreferrer", children: _jsx("span", { className: "aem-pushblock__icon", children: _jsx("span", { className: "icon__wrapper", children: {
                            facebook: _jsx(Facebook, {}),
                            instagram: _jsx(Instagram, {}),
                            telegram: _jsx(Telegram, {}),
                            twitter: _jsx(Twitter, {}),
                            viber: _jsx(Viber, {}),
                            whatsapp: _jsx(Whatsapp, {}),
                        }[iconName] }) }) }) }, idx));
    });
    return (_jsxs("div", { children: [_jsx(ConditionalView, { condition: title.trim() !== "", children: _jsx("h2", { className: "aem-pushblock__title", children: title }) }), _jsx(ConditionalView, { condition: subHeadline.trim() !== "", children: _jsx("h3", { className: "aem-pushblock__subheadline", children: subHeadline }) }), _jsx(ConditionalView, { condition: description.trim() !== "", children: _jsx("div", { className: "aem-pushblock__text aem-text__container", 
                    // eslint-disable-next-line jam3/no-sanitizer-with-danger
                    dangerouslySetInnerHTML: {
                        __html: description,
                    } }) }), _jsx(ConditionalView, { condition: iconList?.length > 0, children: _jsx("ul", { className: "aem-pushblock__icon-list", children: listItems }) })] }));
};
export default TextContainer;
//# sourceMappingURL=TextContainer.js.map